import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ComparePlusIcon from '../../assets/icons/complarePlus'
import { updateComparableSecurities } from '../../reducer/chart.reducer'
import { ExpressionCallbackData } from './typings'
import { selectChartComparableSecurities, selectChartConfig } from '../../selectors/chart'
import { buildComparableSecurityPanePlacements } from '../../util/chart'
import { ExtraSmallButton } from '../custom'
import SecuritySearchModal from './SecuritySearchModal'
import { getSecuritiesFromSecuritiesObj } from '../../util/security'
import { Tooltip } from '@mui/material'
import { Security } from '../../proto/generated/security'

interface Props {
    viewKey: string
    disabled: boolean
}

const SecurityCompare = (props: Props) => {
    const { viewKey, disabled } = props
    const dispatch = useDispatch()
    const currentComparableSecurities: Security[] = useSelector(selectChartComparableSecurities(viewKey))
    const chartCfg = useSelector(selectChartConfig(viewKey))
    const [securitiesModalOpen, setSecuritiesModalOpen] = useState<boolean>(false)

    const onSecuritySelected = async (data: ExpressionCallbackData) => {
        const securities = await getSecuritiesFromSecuritiesObj(data.securities)
        if (!securities) return
        const [security] = securities
        const comparableSecurities = [...currentComparableSecurities]
        comparableSecurities.push(security)

        const panePlacement: 'overlay' | 'new_pane' =
            data.comparePlacement === 'new_pane' ? 'new_pane' : 'overlay'
        const prevPlacements = buildComparableSecurityPanePlacements(
            currentComparableSecurities,
            chartCfg?.comparableSecurityPanePlacement,
            chartCfg?.comparableSecurityPanePlacements
        )
        const comparableSecurityPanePlacements = [...prevPlacements, panePlacement]

        dispatch(
            updateComparableSecurities({
                viewKey,
                comparableSecurities,
                comparableSecurityPanePlacements
            })
        )
        setSecuritiesModalOpen(false)
    }

    return (
        <div>
            <Tooltip title={
                <span
                    style={{ fontSize: '12px' }}>Compare or Add Security</span>}
                arrow placement="bottom">
                <span>
                <ExtraSmallButton
                    size="small"
                    color="inherit"
                    onClick={() => {
                        setSecuritiesModalOpen(true)
                    }}
                    disabled={disabled}
                    data-event={'Compare Security Opened'}
                    data-event-source={'stockbar'}
                >
                    <ComparePlusIcon />
                </ExtraSmallButton>
                </span>
            </Tooltip>
            {
                securitiesModalOpen && <SecuritySearchModal
                    open={securitiesModalOpen}
                    enableExpressions={false}
                    compareSecurityPicker
                    onCloseClicked={() => {
                        setSecuritiesModalOpen(false)
                    }}
                    onSecuritySelected={onSecuritySelected}
                />
            }
        </div>
    )
}
export default React.memo(SecurityCompare)
